<template>
  <v-card id="list-user">
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title class="col-6">
          {{ resx.labels.users }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="fixed-header">
      <v-row >
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-col>
          <v-row
            class="float-center px-2 actionButton "
            v-if="
              $store.state.auth.user.roles[0] ==
                $store.state.constants.roles.SYS_ADMIN
            "
          >
            <v-list-item-content>Mostrar usuarios borrados</v-list-item-content>
            <v-switch
              v-model="showDeletedUsers">
            </v-switch>
          </v-row>
          <v-row class="float-right">
            <v-col>
              <span v-if="users.length > 0">{{
                `${
                  resx.labels.countItems
                } ${resx.labels.users.toLowerCase()}: ${count}`
              }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="table-container">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="users"
            :loading=loading
            :search="search"
            :no-data-text="resx.messages.noUsersAvailable"
            :no-results-text="resx.messages.noUsersFound"
            fixed-header
            height="auto"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            ref="dataTable"
            sort-by="username"
            loading-text=""
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>
            <template v-slot:item.username="{ item }">
              <td>
                <a @click.prevent="editUser(item)">{{ item.username }}</a>
              </td>
            </template>
            <template v-slot:item.roles="{ item }">
              <td class="hidden-sm-and-down">
                {{ getRoleName(item.roles[0]) }}
              </td>
            </template>
            <template v-slot:item.company="{ item }">
              <td
                class="hidden-sm-and-down"
                v-if="
                  $store.state.auth.user.roles[0] ==
                    $store.state.constants.roles.SYS_ADMIN
                "
              >
                {{ item.company.name }}
              </td>
            </template>
            <template v-slot:item.isActive="{ item }">
              <td
                class="hidden-sm-and-down"
                :class="[item.isActive ? 'success--text' : 'error--text']"
              >
                {{ item.isActive ? resx.labels.active : resx.labels.inactive }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editUser(item)">
                      <v-list-item-action>
                        <v-icon color="primary">mode_edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.edit
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changePassword(item)">
                      <v-list-item-action>
                        <v-icon color="primary">security</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.changePassword
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="deleteUser(item)">
                      <v-list-item-action>
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.delete
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="newUser()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>

      <v-row>
        <v-dialog
          persistent
          :value="showEditUser"
          @input="cancelEdit()" width="800"
          @keydown.esc="cancel()"
        >
          <edit-user
            ref="editUserComponent"
            :user="userForEdit"
            @cancel="cancelEdit()"
            @saved="userSaved($event)"
          />
        </v-dialog>
        <admin-change-password
          v-model="changePasswordData"
        />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";
import userService from "@/services/UserService";
import editUser from "@/components/views/users/edit-user.view.vue";
import BarLoader from "@/components/common/bar-loader.vue"; 

import {
  default as adminChangePassword,
  mixin as adminChangePasswordMixin
} from "./admin-change-password.view.vue";

export default {
  async mounted() {
    this.users = await userService.getUsers();
    this.roles = await userService.getRoles();

    // Hide column for other roles than SYS_ADMIN...very ugly
    if (
      this.$store.state.auth.user.roles[0] !=
      this.$store.state.constants.roles.SYS_ADMIN
    ) {
      this.headers = this.headers.filter(
        h => h.text != this.resx.labels.company
      );
    }
    this.loading = false;
  },
  components: {
    editUser,
    adminChangePassword,
    BarLoader
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      showEditUser: false,
      userForEdit: null,
      headers: [
        {
          text: resx.labels.username,
          value: "username"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.firstname,
          value: "firstname"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.lastname,
          value: "lastname"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.role,
          value: "roles"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.company,
          value: "company.name"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.email,
          value: "email"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.state,
          value: "isActive"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        }
      ],
      users: [],
      roles: [],
      showDeletedUsers: false,
      loading: true
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    getRoleName(roleCode) {
      const role = this.roles.find(role => {
        return role.code == roleCode;
      });
      if (!role) {
        return roleCode;
      }
      return role.name;
    },
    editUser(user) {
      this.userForEdit = JSON.parse(JSON.stringify(user));
      this.showEditUser = true;
    },
    newUser() {
      this.userForEdit = {
        username: null,
        password: null,
        firstname: null,
        lastname: null,
        email: null,
        isActive: true,
        company: null,
        roles: []
      };
      this.showEditUser = true;
    },
    deleteUser(user) {
      const vm = this;
      this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.user.toLowerCase()}`,
        content: sprintf(this.resx.messages.deleteUserMessage, user.username)
      }).then(function() {
        userService.deleteUser(user._id).then(() => {
          const index = vm.users.indexOf(user);
          vm.users.splice(index, 1);
        });
      });
    },
    changePassword(user) {
      this.changePasswordOpen(user);
    },
    cancelEdit() {
      this.showEditUser = false;
      this.userForEdit = null;
    },
    userSaved(result) {
      if (result.isNew) {
        this.users.push(result.user);
      } else {
        let index = this.users.findIndex(user => {
          return user._id == result.user._id;
        });
        this.$set(this.users, index, result.user);
      }
      this.cancelEdit();
    },
  },
  computed: {
    count: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    },
  },
  watch: {
    async showDeletedUsers(val) {
      this.users = await userService.getUsers(val);
    }
  },
  mixins: [adminChangePasswordMixin]
};
</script>

<style lang="scss">
#list-user {
  .v-card__text .table-container {
    padding-bottom: 50px;
  }
}

.addButton.v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom {
  position: fixed;
  bottom: 101px;
  right: 35px;
}

.v-data-table__wrapper {
  height: max-content;
}

.row.count-items {
  margin-top: 0;
}

.v-card .v-card-title {
  margin-top: 600px;
}

.v-card {
  overflow-y: auto;
  height: 100%;
}
</style>
